import { render, staticRenderFns } from "./sesEmailLog.vue?vue&type=template&id=6356d852"
import script from "./sesEmailLog.vue?vue&type=script&lang=js"
export * from "./sesEmailLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports